enum ActionTypes {
  REJECT = 'Signature/REJECT',
  REJECT_REQUEST = 'Signature/REJECT_REQUEST',
  REJECT_SUCCESS = 'Signature/REJECT_SUCCESS',
  REJECT_FAILURE = 'Signature/REJECT_FAILURE',
}

export default ActionTypes;
